import { render, staticRenderFns } from "./dashboardTickets.vue?vue&type=template&id=712361d0&scoped=true&"
import script from "./dashboardTickets.vue?vue&type=script&lang=js&"
export * from "./dashboardTickets.vue?vue&type=script&lang=js&"
import style0 from "./dashboardTickets.vue?vue&type=style&index=0&id=712361d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712361d0",
  null
  
)

export default component.exports